export default __webpack_public_path__ + "static/media/list_2.1467771c.png";